import React, { useState, useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import ACSnackbar from '../components/ACSnackbar';
import AdvisorPublicJoinForm from '../components/Advisor/PublicJoinForm';
import PublicRegistration from '../layouts/PublicRegistration';
import { advisorPublicJoin } from '../services/advisor_services';
import { getCompanyPublicInfoBySlug } from '../services/company_services';

const AdvisorPublicJoin = () => {
  const { companySlug, companyId } = useParams('/join/advisors/:companySlug/:companyId');
  const location = useLocation();
  const history = useHistory();

  const params = new URLSearchParams(location.search);
  const utmParams = {
    utmAdGroup: params.get('utm_adgroup') || "",
    utmCampaign: params.get('utm_campaign') || "",
    utmContent: params.get('utm_content') || "",
    utmDevice: params.get('utm_device') || "",
    utmKeyword: params.get('utm_keyword') || "",
    utmMatchType: params.get('utm_matchtype') || "",
    utmMedium: params.get('utm_medium') || "",
    utmNetwork: params.get('utm_network') || "",
    utmPlacement: params.get('utm_placement') || "",
    utmSource: params.get('utm_source') || "",
  };

  const [companyDisplayName, setCompanyDisplayName] = useState('');
  const [boardOwnerName, setBoardOwnerName] = useState('');
  const [image, setImage] = useState(null);
  const [error, setError] = useState('Something went wrong');
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    const getCompanyInfo = async () => {
      try {
        const response = await getCompanyPublicInfoBySlug({
          slug: companySlug,
          preventWithOwnerImage: true,
        });
        setImage(response.data.getCompany.image);
        setCompanyDisplayName(response.data.getCompany.displayName);
        const owner = response.data.getCompany.contacts?.find((c) => c.isBoardOwner);
        if (owner) {
          setBoardOwnerName(`${owner.givenName} ${owner.surName}`);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getCompanyInfo();
  }, [companySlug]);

  const onSubmit = async ({ givenName, surName, email }) => {
    try {
      const response = await advisorPublicJoin({
        givenName,
        surName,
        email,
        companyId,
        ...utmParams,
      });

      if (response.errors) {
        setError(getError(response));
        setShowSnackbar(true);
      } else {
        let params = `?first_name=${givenName}&last_name=${surName}&companyName=${companyDisplayName}&email=${email}&plan=b2c-freemium-company-invitee`;
        const redirectUrl = response?.data?.advisorPublicJoin?.checkoutRedirectUrl + params;
        if (redirectUrl) {
          console.log('Redirecting to:', redirectUrl);
          window.location.assign(redirectUrl);
        } else {
          history.push(`/advisor/confirmation?email=${email}`);
        }
      }
    } catch (error) {
      console.log(error);
      setShowSnackbar(true);
    }
  };

  return (
    <>
      <ACSnackbar
        onClose={() => setShowSnackbar(false)}
        open={showSnackbar}
        severity="error"
        text={error}
      />
      <PublicRegistration>
        <AdvisorPublicJoinForm
          companySlug={companyDisplayName}
          boardOwnerName={boardOwnerName}
          onSubmit={onSubmit}
          image={image}
        />
      </PublicRegistration>
    </>
  );
};

export default AdvisorPublicJoin;
